WL.registerComponent(
	"view-360",
	{
		nonVrCamera: { type: WL.Type.Object },
	},
	{
		start: function () {
			//create device orientation-look if it doesnt exist
			this.orientationComponent = this.nonVrCamera.getComponent("device-orientation-look") || this.nonVrCamera.addComponent("device-orientation-look");
			window.view360 = false;
			this.createDynamicHtml();
		},
		update: function () {
			//turns on 360 degree device orientation for mobile ( based on view360 ,toggled by user input )
			this.orientationComponent.active = window.view360;
		},

		createDynamicHtml: function () {
			const icon360Src = "images/icon-360.png";
			if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
				const icon360 = document.createElement("img");
				icon360.src = icon360Src;
				icon360.draggable = "false";
				icon360.type = "button";
				icon360.id = "icon360";
				icon360.setAttribute(
					"onclick",
					"if(window.view360 == null)window.view360=true;window.view360 = !window.view360;"
				);
				icon360.setAttribute("data-loaded", "false");
				icon360.setAttribute(
					"style",
					"border:10px; bottom:10px; height:50px;width:50px;left:5px; position:absolute;"
				);
				document.body.appendChild(icon360);
			}
		},
	}
);
